module.exports = ".movable_div p, h4{\r\n    color:red;\r\n}\r\n\r\n.checking{\r\n    padding-left: 0.5px;\r\n}"